import { ButtonSize } from '../types/styled'

export function getIconButtonSize(size: ButtonSize): string {
  switch (size) {
    case 's':
      return '24px'
    case 'l':
      return '42px'
    case 'm':
    default:
      return '30px'
  }
}

export function getIconButtonPadding(size: ButtonSize): string {
  switch (size) {
    case 's':
      return '5px'
    case 'l':
      return '8px'
    case 'm':
    default:
      return '6px'
  }
}

export function getIconSize(size: ButtonSize): number {
  switch (size) {
    case 's': return 15
    case 'l': return 20
    case 'm':
    default:
      return 18
  }
}